import { render, staticRenderFns } from "./product-sort-details.vue?vue&type=template&id=5f24a4f7&scoped=true&"
import script from "./product-sort-details.vue?vue&type=script&lang=js&"
export * from "./product-sort-details.vue?vue&type=script&lang=js&"
import style0 from "./product-sort-details.vue?vue&type=style&index=0&id=5f24a4f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f24a4f7",
  null
  
)

export default component.exports